(() => {
  const checkoutUrl = `${window.Shopify?.routes?.root || '/'}checkout`;
  const cartAddUrl = window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.petrons-buy-now[data-variant-id]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    event.preventDefault();
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    const cardActions = button.closest('.petrons-card-actions');
    const quantityInput = cardActions?.querySelector('quick-add-bulk .quantity__input');
    const quantityInCart = Number.parseInt(quantityInput?.value || '0', 10);
    const minimumQuantity = Number.parseInt(button.dataset.minimumQuantity || '1', 10);

    try {
      if (quantityInCart < 1) {
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number.parseInt(button.dataset.variantId, 10),
                quantity: Math.max(minimumQuantity, 1),
              },
            ],
          }),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Unable to add this product.');
        }
      }

      window.location.assign(checkoutUrl);
    } catch (error) {
      console.error(error);
      button.removeAttribute('aria-busy');
      button.disabled = false;
      window.alert('לא ניתן להוסיף את המוצר כרגע. נסו שוב או פנו אלינו בוואטסאפ.');
    }
  });
})();
